import React from 'react';

interface SnagSolutionsIconProps {
  height?: number;
  className?: string;
}

export const SnagSolutionsLogo: React.FC<SnagSolutionsIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      height={height}
      width={height}
      viewBox="0 0 453 495"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M182.633 11.636C209.525 -3.87868 242.649 -3.87867 269.541 11.636L408.672 91.9036C435.59 107.433 452.174 136.148 452.174 167.224V327.648C452.174 358.724 435.59 387.439 408.672 402.968L269.541 483.236C242.649 498.75 209.525 498.75 182.633 483.236L43.5024 402.968C16.5843 387.439 0 358.724 0 327.648V167.224C0 136.148 16.5844 107.433 43.5024 91.9036L182.633 11.636Z"
        fill="url(#paint0_linear_55_1833)"
      />
      <path
        d="M291.339 308.733L233.04 427.223C231.818 429.71 229.546 431.273 226.853 431.531L226.056 431.562L225.259 431.531C222.567 431.273 220.299 429.71 219.073 427.223L160.773 308.733H160.782H291.339Z"
        fill="url(#paint1_linear_55_1833)"
      />
      <path
        d="M34.8175 246.997C35.0014 249.488 36.0043 251.655 37.817 253.468L208.446 423.987C213.135 428.672 218.77 431.203 225.264 431.531C222.571 431.273 220.303 429.71 219.077 427.223L160.786 308.715L34.8175 246.997Z"
        fill="url(#paint2_linear_55_1833)"
      />
      <path
        d="M417.278 246.997C417.094 249.488 416.091 251.655 414.279 253.468L243.65 423.987C238.96 428.672 233.326 431.203 226.832 431.531C229.525 431.273 231.793 429.71 233.019 427.223L291.309 308.715L417.278 246.997Z"
        fill="url(#paint3_linear_55_1833)"
      />
      <path
        d="M160.782 308.729H160.835L223.048 65.4083C223.363 64.1692 224.362 63.2847 225.588 63.0964C225.338 63.0877 225.084 63.0833 224.835 63.0964C224.274 63.1096 223.714 63.1271 223.153 63.1534C218.482 63.5387 213.923 65.5002 210.333 69.0337L37.8739 238.774C35.8292 240.783 34.7956 243.244 34.7825 246.112C34.7825 246.414 34.7914 246.708 34.8133 247.001L160.782 308.729Z"
        fill="url(#paint4_linear_55_1833)"
      />
      <path
        d="M291.392 308.729H291.339L229.125 65.4083C228.81 64.1692 227.812 63.2847 226.586 63.0964C226.836 63.0877 227.089 63.0833 227.339 63.0964C227.899 63.1096 228.460 63.1271 229.02 63.1534C233.692 63.5387 238.25 65.5002 241.841 69.0337L414.3 238.774C416.344 240.783 417.378 243.244 417.391 246.112C417.391 246.414 417.382 246.708 417.36 247.001L291.392 308.729Z"
        fill="url(#paint5_linear_55_1833)"
      />
      <path
        d="M291.339 308.733L229.126 65.4127C228.81 64.1736 227.812 63.2891 226.586 63.1009H225.583C224.357 63.2891 223.364 64.1736 223.044 65.4127L160.83 308.733H291.339Z"
        fill="url(#paint6_linear_55_1833)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_55_1833"
          x1="226.084"
          y1="508.312"
          x2="226.084"
          y2="-13.432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#471695" />
          <stop offset="1" stopColor="#7B00F7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_55_1833"
          x1="226.056"
          y1="308.733"
          x2="226.056"
          y2="431.562"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDA349" />
          <stop offset="1" stopColor="#FEB549" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_55_1833"
          x1="130.041"
          y1="246.997"
          x2="130.041"
          y2="431.531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE763C" />
          <stop offset="1" stopColor="#FE9943" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_55_1833"
          x1="322.055"
          y1="246.997"
          x2="322.055"
          y2="431.531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE763C" />
          <stop offset="1" stopColor="#FE9943" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_55_1833"
          x1="130.185"
          y1="63.0881"
          x2="130.185"
          y2="308.729"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE7C11" />
          <stop offset="1" stopColor="#FEB11C" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_55_1833"
          x1="321.989"
          y1="63.0881"
          x2="321.989"
          y2="308.729"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE7C11" />
          <stop offset="1" stopColor="#FEB11C" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_55_1833"
          x1="226.085"
          y1="63.1009"
          x2="226.085"
          y2="308.733"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEA31C" />
          <stop offset="1" stopColor="#FDC81C" />
        </linearGradient>
      </defs>
    </svg>
  );
};
